(function() { window.GUID_509a4eee_6f9f_4191_8a44_994ab3030225 = { getGuid: function() { return "509a4eee-6f9f-4191-8a44-994ab3030225"; } }; })();
var Account;
(function (Account) {
    function BindButtons() {
        var fbLoginApp = $('#FacebookLogin');
        var fbLogout = $('#FacebookLogout');
        fbLogout.off('click');
        fbLogout.on('click', function () {
            var forcePassword = fbLoginApp.hasClass('ForcePassword');
            var $IsKiosk = $('#IsKiosk');
            var isKiosk = $IsKiosk.length > 0 && $IsKiosk.val() != null && $IsKiosk.val() == 'value' ? true : false;
            if (isKiosk) {
                FB.getLoginStatus(function (statusResponse) {
                    console.log("isKiosk status : " + statusResponse.status);
                    if (statusResponse.status === 'connected') {
                        FB.logout(function (e) {
                            console.log("isKiosk Logged out : " + e.status);
                        });
                    }
                });
            }
        });
        fbLoginApp.off('click');
        fbLoginApp.on('click', function () {
            var forcePassword = fbLoginApp.hasClass('ForcePassword');
            var $IsKiosk = $('#IsKiosk');
            var isKiosk = $IsKiosk.length > 0 && $IsKiosk.val() != null && $IsKiosk.val() == 'value' ? true : false;
            if (isKiosk) {
                //FB.getLoginStatus(function (statusResponse) {
                //    console.log("isKiosk status : " + statusResponse.status);
                //    if (statusResponse.status === 'connected') {
                //        FB.logout(function (e) {
                //            FB.login(function (response) {
                //                checkLoginStatusCallback(response, 'LoginFacebook', null, isKiosk);
                //            }, { scope: 'email', auth_type: forcePassword ? 'reauthenticate' : '' });
                //        });
                //    } else {
                FB.login(function (response) {
                    console.log("isKiosk not connected : " + response.status);
                    checkLoginStatusCallback(response, 'LoginFacebook', null, isKiosk);
                }, { scope: 'email', auth_type: forcePassword ? 'reauthenticate' : '' });
                //}
                //                });
            }
            else {
                console.log("FB.login");
                FB.login(function (response) {
                    checkLoginStatusCallback(response, 'LoginFacebook', null, isKiosk);
                }, { scope: 'email', auth_type: forcePassword ? 'reauthenticate' : '' });
            }
        });
    }
    Account.BindButtons = BindButtons;
    CS.FormReady(function (formId) {
        BindButtons();
        var validationEmailAgain = $('#ValidationEmailAgain');
        validationEmailAgain.off('click');
        var alreadyPost = false;
        if (formId == "Login") {
            validationEmailAgain.on('click', function (e) {
                e.preventDefault();
                if (alreadyPost) {
                    return;
                }
                alreadyPost = true;
                $('#SendEmailValidation').val('true');
                var loginFrm = $('#Login');
                loginFrm.submit();
            });
        }
    });
})(Account || (Account = {}));

//# sourceMappingURL=Account.js.map
